import StatSpy from './stat-spy.js';

// Default options for the plugin.
const DEFAULTS = {

};

/**
 * The Stat class to eval defined function.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends StatSpy
 */

class StatEval extends StatSpy {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options);
		super(player, options_);
		this.sender = options_.sender;
	}

	send(ev) { 
		super.send(ev);
		this.utils.processVal.call(this, this.sender, ev);
	}
}

export default StatEval;
